__turbopack_context__.v({
  "complimentary": "LinePrice-module-scss-module__DToB7q__complimentary",
  "container": "LinePrice-module-scss-module__DToB7q__container",
  "originalPrice": "LinePrice-module-scss-module__DToB7q__originalPrice",
  "price": "LinePrice-module-scss-module__DToB7q__price",
});
